import { Component, ElementRef, inject, signal } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

import { AuthService } from '../../../shared/services/auth.service';
import { RegistreService } from '../../../shared/services/registre.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../../core/dialog/dialog.component';
import { DialogDynamicComponent } from '../../../core/dialog/dialog-dynamic/dialog-dynamic.component';
import { gitVersions } from '../../../../environments/versions';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';
import { MatDivider } from '@angular/material/list';
import { UiStore } from '../../../shared/state/ui.store';


@Component({
    selector: 'app-nav-user',
    templateUrl: './nav-user.component.html',
    styleUrls: ['./nav-user.component.scss'],
    // meniul se inchide la click in afara lui
    host: {
        '(document:click)': 'onDocumentClick($event.target)',
        '(document:keydown.escape)': 'isOpen.set(false)',
    },
    imports: [MatButton, MatIcon, MatRipple, MatDivider, NgOptimizedImage]
})
export class NavUserComponent {
    private _elementRef = inject(ElementRef);
    private readonly auth = inject(AuthService);
    private regServ = inject(RegistreService);
    dialog = inject(MatDialog);


    protected readonly isOpen = signal(false);
    // currentUser = null;
    protected readonly currentUser = inject(UiStore).user;

    onDocumentClick(targetElement: EventTarget | null) {
        if (!targetElement) {
            return;
        }
        const clickedInside = this._elementRef.nativeElement.contains(targetElement as Node);
        if (!clickedInside) {
            this.isOpen.set(false);
        }
    }


    toggleDropDown() {
        this.isOpen.update(open => !open);
    }

    iesire() {
        this.isOpen.set(false);
        this.auth.iesire();
    }

    refresh() {
        this.regServ.getRegistre();
    }

    get_anyDesk() {
        window.open('https://anydesk.com/en', '_blank');
    }

    showVersion() {
        this.dialog.open(
            DialogComponent, {
            height: '400px',
            width: '600px',
            closeOnNavigation: false,
            disableClose: true,
            data: {
                component: DialogDynamicComponent,
                appVersion: gitVersions,
            }
        }
        );
    }

}
